/* eslint-disable react/prop-types */
import { debounce } from 'lodash';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useState } from 'react';
// components
import SmallLoading from '../../../Components/element/SmallLoading';
import { AutocompleteV2 } from 'shared/components/autocomplete-v2';
import { Box } from '@radix-ui/themes';
import { SearchCityStore } from './SearchCityStore';
import { useDebouncedCallback } from 'use-debounce';
import { observer } from 'mobx-react-lite';
import InputDate from 'Components/forms/components/InputDate';
const ApplyJobInfoFormView = ({
   errors,
   setStep,
   editInfo,
   formData,
   onSubmit,
   setErrors,
   setFormData,
   isSubmitting,
   subscribeAlert,
   setSubscribeAlert,
}) => {
   const { t } = useTranslation('global');
   const [searchCityStore] = useState(() => new SearchCityStore());
   const debouncedCities = useDebouncedCallback((q) => {
      searchCityStore.getCities({ query: q });
   }, 500);

   const [contactNumber, setContactNumber] = useState(formData.contact || '');

   const handleChange = (e) => {
      const { name, value } = e.target;

      setFormData((prevData) => ({
         ...prevData,
         [name]: value.trim(),
      }));

      setErrors((prev) => ({
         ...prev,
         [name]: '',
      }));
   };

   const handleContactNumberChange = useCallback((e) => {
      const { value } = e.target;

      setContactNumber(value.trim());
      debouncedHandleInputChange(value.trim());
   }, []); // eslint-disable-line

   const handleFocus = (e) => {
      const { value } = e.target;

      if (value) return;

      setContactNumber('+38');
   };

   const handleBlur = (e) => {
      const { value } = e.target;
      const updatedValue = value === '+38' ? '' : value;

      setContactNumber(updatedValue);
   };

   const debouncedHandleInputChange = debounce((value) => {
      setFormData((prev) => ({
         ...prev,
         contact: value,
      }));

      setErrors((prev) => ({
         ...prev,
         contact: '',
      }));
   }, 500);

   return (
      <form
         onSubmit={onSubmit}
         className="radix-themes"
         data-accent-color="red"
         data-gray-color="slate"
         data-radius="medium"
         data-scaling="100%"
      >
         <div className="mb-4">
            <label className="mb-2 fw-bold" htmlFor="first_name">
               {t('jobDescription.firstName')}
               <span className="RedStar">*</span>
            </label>
            <input
               type="text"
               id="first_name"
               name="first_name"
               disabled={editInfo}
               onChange={handleChange}
               value={formData.first_name}
               placeholder={t('jobDescription.firstNamePlaceholder')}
               className={`form-control ${errors.first_name && 'input-error'}`}
            />
            {errors.first_name && <div className="text-danger">{errors.first_name}</div>}
         </div>
         <div className="mb-4">
            <label className="mb-2 fw-bold" htmlFor="last_name">
               {t('jobDescription.lastName')}
               <span className="RedStar">*</span>
            </label>
            <input
               type="text"
               id="last_name"
               name="last_name"
               disabled={editInfo}
               onChange={handleChange}
               value={formData.last_name}
               placeholder={t('jobDescription.lastNamePlaceholder')}
               className={`form-control ${errors.last_name && 'input-error'}`}
            />
            {errors.last_name && <div className="text-danger">{errors.last_name}</div>}
         </div>
         <div className="mb-4">
            <label className="mb-2 fw-bold" htmlFor="email_address">
               {t('jobDescription.email')}
            </label>
            <input
               id="email_address"
               disabled={editInfo}
               name="email_address"
               type="email_address"
               onChange={handleChange}
               value={formData.email_address}
               placeholder={t('jobDescription.emailPlaceholder')}
               className={`form-control ${errors.email_address && 'input-error'}`}
            />
            {errors.email_address && <div className="text-danger">{errors.email_address}</div>}
         </div>
         <div className="mb-4">
            <label className="mb-2 fw-bold" htmlFor="contact">
               {t('jobDescription.contact')}
            </label>
            <input
               type="tel"
               id="contact"
               name="contact"
               onBlur={handleBlur}
               onFocus={handleFocus}
               value={contactNumber}
               onChange={handleContactNumberChange}
               placeholder={t('jobDescription.contactPlaceholder')}
               className={`form-control ${errors.contact && 'input-error'}`}
            />
            {errors.contact && <div className="text-danger">{errors.contact}</div>}
         </div>

         <Box mb="4">
            <label className="mb-2 fw-bold" htmlFor="contact">
               Місто
            </label>
            <AutocompleteV2.Root
               placeholder="Оберіть місто"
               selectedKey={searchCityStore?.selected?.id || null}
               items={searchCityStore.cities}
               loading={searchCityStore.citiesLoading}
               getOptionValue={(city) => city.id}
               getOptionLabel={(city) => city.name}
               onSelect={(loc) => {
                  searchCityStore.setSelected(loc);
                  setFormData((p) => ({ ...p, city_id: loc.id }));
               }}
               onSearch={(v) => {
                  setFormData((p) => ({ ...p, city_id: '' }));
                  debouncedCities(v);
               }}
            ></AutocompleteV2.Root>
         </Box>

         <Box mb="4">
            <label className="mb-2 fw-bold" htmlFor="contact">
               Дата народження
            </label>

            <InputDate
               name="birthday"
               minDate="1930-01-01"
               value={formData.birthday}
               handleChange={(e) => {
                  setFormData((p) => ({ ...p, birthday: e.target.value }));
               }}
               maxDate={new Date().toISOString().split('T')[0]}
            />
         </Box>

         <div className="mb-4">
            {editInfo ? (
               <>
                  <div className="subscribeAlertBox">
                     <label className="subscribeAlertLabel">
                        <input
                           type="checkbox"
                           name="subscribeAlert"
                           checked={subscribeAlert}
                           className="me-2 subscribeAlertCheckbox"
                           onChange={() => setSubscribeAlert((prevState) => !prevState)}
                        />
                        {t('jobDescription.subscribeAlert')}
                     </label>
                  </div>
                  <div className="dataProcessingConsentBox">
                     <p>
                        {t('jobDescription.bottomTxt1')}{' '}
                        <Link to="/data-processing-consent">{t('jobDescription.bottomTxt2')}</Link>
                     </p>
                  </div>
               </>
            ) : (
               <p className="">
                  {t('employerRegister.bottomTxt1')}{' '}
                  <Link to="/terms-of-use">{t('employerRegister.bottomTxt2')}</Link>
                  {', '}
                  {t('employerRegister.bottomTxt7')}{' '}
                  <Link to="/offer-agreement">{t('employerRegister.bottomTxt8')}</Link>{' '}
                  {t('employerRegister.bottomTxt5')}{' '}
                  <Link to="/data-processing-consent">{t('employerRegister.bottomTxt6')}</Link>
               </p>
            )}
         </div>
         <div className="d-flex justify-content-evenly">
            {editInfo && (
               <button
                  type="button"
                  className="btn button2"
                  onClick={() => setStep('questionnaire')}
               >
                  {t('jobDescription.backButton')}
               </button>
            )}
            {editInfo ? (
               <button
                  type="submit"
                  onClick={() => {}}
                  disabled={isSubmitting}
                  className="mt-0 btn button1"
               >
                  {t('jobDescription.applyNow')}{' '}
                  {isSubmitting && <SmallLoading width="16px" height="16px" />}
               </button>
            ) : (
               <button
                  type="submit"
                  onClick={onSubmit}
                  disabled={isSubmitting}
                  className="mt-0 btn button1"
               >
                  {t('jobDescription.continueButton')}{' '}
                  {isSubmitting && <SmallLoading width="24px" height="24px" color="#FFF" />}
               </button>
            )}
         </div>
      </form>
   );
};
const ApplyJobInfoForm = observer(ApplyJobInfoFormView);
export default ApplyJobInfoForm;
